module.exports = __webpack_public_path__ + "static/media/xcultural1.048cffd2.jpg";